import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setAguardando(aguardando) {
    return {
        type: 'DASHBOARD_CUSTO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getListaCustoFolha(filtro) {
    const request = axios.get(`${consts.API_URL}/custoFolhaMes/dashboard`, { 
        params: {
            ids_unidades: filtro.ids_unidades
        }
    });
    return {
        type: 'DASHBOARD_CUSTO_FOLHA_LISTADO',
        payload: request
    };
}

export function getListaCustoFrota(filtro) {
    const request = axios.get(`${consts.API_URL}/custoFrotaMes/dashboard`, { 
        params: {
            ids_unidades: filtro.ids_unidades
        }
    });
    return {
        type: 'DASHBOARD_CUSTO_FROTA_LISTADO',
        payload: request
    };
}

export function getListaCustoVendas(filtro) {
    const request = axios.get(`${consts.API_URL}/custoImportacaoMes/dashboardCustoVendasMes`, { 
        params: {
            ids_unidades: filtro.ids_unidades
        }
    });
    return {
        type: 'DASHBOARD_CUSTO_VENDAS_LISTADO',
        payload: request
    };
}

export function getListaCustoInvestimentos(filtro) {
    const request = axios.get(`${consts.API_URL}/custoImportacaoMes/dashboardCustoInvestimentosMes`, { 
        params: {
            ids_unidades: filtro.ids_unidades
        }
    });
    return {
        type: 'DASHBOARD_CUSTO_INVESTIMENTOS_LISTADO',
        payload: request
    };
}

export function getListaReceitaFrete(filtro) {
    const request = axios.get(`${consts.API_URL}/receitaImportacaoMes/dashboardFretes`, { 
        params: {
            ids_unidades: filtro.ids_unidades
        }
    });
    return {
        type: 'DASHBOARD_CUSTO_RECEITA_FRETE_LISTADO',
        payload: request
    };
}

export function getListaCustoOutrasDespesas(filtro) {
    const request = axios.get(`${consts.API_URL}/custoImportacaoMes/dashboardOutrasDespesas`, { 
        params: {
            ids_unidades: filtro.ids_unidades
        }
    });
    return {
        type: 'DASHBOARD_CUSTO_OUTRAS_DESPESAS_LISTADO',
        payload: request
    };
}

export function getListaCustoAbastecida(filtro) {
    const request = axios.get(`${consts.API_URL}/saida/dashboardCusto`, { 
        params: {
            ids_unidades: filtro.ids_unidades
        }
    });
    return {
        type: 'DASHBOARD_CUSTO_ABASTECIDA_LISTADO',
        payload: request
    };
}

export function getListaKmRodado(filtro) {
    const request = axios.get(`${consts.API_URL}/veiculo/listarDashboardCustoKmRodadoMes`, { 
        params: {
            ids_unidades: filtro.ids_unidades
        }
    });
    return {
        type: 'DASHBOARD_CUSTO_KM_RODADO_LISTADO',
        payload: request
    };
}

export function getListaVenda(filtro) {
    const request = axios.get(`${consts.API_URL}/vendaImportacao/listarDashboardCusto`, { 
        params: {
            ids_unidades: filtro.ids_unidades
        }
    });
    return {
        type: 'DASHBOARD_CUSTO_VENDA_LISTADO',
        payload: request
    };
}

export function salvarCustoFolha(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/custoFolhaMes`, {
				...registro,
				valor: FormatUtils.formatarValorBanco(registro.valor, 2),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getListaCustoFolha());
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/custoFolhaMes`, {
				...registro,
				valor: FormatUtils.formatarValorBanco(registro.valor, 2),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getListaCustoFolha());
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluirCustoFolha(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/custoFolhaMes?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getListaCustoFolha());
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaUnidade() {
    const request = axios.get(`${consts.API_URL}/unidade/listarSelect`);
    return {
        type: 'DASHBOARD_CUSTO_UNIDADE_SELECT_LISTADO',
        payload: request
    };
}